import { LockIcon } from 'lucide-react'

import { QuestionnaireStatus } from '@/gen/questionnaire/common/v1/questionnaire_status_pb'

import { Badge, BadgeProps } from '@/components/lemmala-design-system/badge/badge'
import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'
import { smartEvidenceRequestStatusLabel } from '@/components/shared/smart-evidence-request-status-badge/labels'

const smartEvidenceRequestStatusVariant: Record<QuestionnaireStatus, BadgeProps['variant']> = {
  [QuestionnaireStatus.ONGOING]: 'promotion',
  [QuestionnaireStatus.SUBMITTED]: 'attention',
  [QuestionnaireStatus.COMPLETED]: 'success',
  [QuestionnaireStatus.EXPIRED]: 'danger',
  [QuestionnaireStatus.DRAFT]: 'neutral',
  [QuestionnaireStatus.UNSPECIFIED]: 'neutral',
}

type SmartEvidenceRequestStatusIconProps = {
  status: QuestionnaireStatus
}

const SmartEvidenceRequestStatusIcon = ({ status }: SmartEvidenceRequestStatusIconProps) => {
  switch (status) {
    case QuestionnaireStatus.SUBMITTED:
      return <LockIcon className='size-3' />
    default:
      return null
  }
}

type SmartEvidenceRequestStatusBadgeProps = {
  status: QuestionnaireStatus
}

export const SmartEvidenceRequestStatusBadge = ({
  status,
}: SmartEvidenceRequestStatusBadgeProps) => {
  return (
    <Badge
      variant={smartEvidenceRequestStatusVariant[status]}
      textCase='title'
      className='text-nowrap'
    >
      <TextWithIcon
        text={smartEvidenceRequestStatusLabel[status]}
        icon={<SmartEvidenceRequestStatusIcon status={status} />}
      />
    </Badge>
  )
}
